import { render, staticRenderFns } from "./ModalOrderDetails.vue?vue&type=template&id=f351604a&lang=pug&"
import script from "./ModalOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ModalOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports